// extracted by mini-css-extract-plugin
export default {"colorit":"socialcause_colorit__11uaQ","flipimageit":"socialcause_flipimageit__-3t2b"};